import { alpha } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const useShadowStyle = () => {
    const theme = useTheme();
    return {
        filter: `drop-shadow(-${theme.outline}px -${theme.outline}px ${theme.blur}px ${alpha(
            theme.palette.primary.shadow,
            theme.alpha
        )})
    drop-shadow(${theme.outline}px -${theme.outline}px ${theme.blur}px ${alpha(
    theme.palette.primary.shadow,
    theme.alpha
)})
    drop-shadow(-${theme.outline}px ${theme.outline}px ${theme.blur}px ${alpha(
    theme.palette.primary.shadow,
    theme.alpha
)})
    drop-shadow(${theme.outline}px ${theme.outline}px ${theme.blur}px ${alpha(
    theme.palette.primary.shadow,
    theme.alpha
)})`,
    };
};
